export enum ReportsSubFeatures {
  QUOTES = 'quotes',
  COMMISSIONS = 'commissions',
  EXCHANGE = 'exchange',
}
